<template>
  <section>
    <!-- Componentes externos -->
    <FinalizarProgramacionesDelMinisterio />
    <InformacionProgramacionDelMinisterio />
    <v-card>
      <h3 class="primary--text">
        <v-icon color="primary">event</v-icon> Programación de vacaciones
      </h3>
      <v-card-text>
        <v-data-table
          class="elevation-1 tabla-comprimida-light"
          :items="lista_gestiones"
          hide-actions
          :headers="headers"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.gestion }}</td>
            <td class="text-xs-center">
              {{ $moment(props.item.fecha_inicio).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(props.item.fecha_fin).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(props.item.fecha_corte).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{
                props.item.fecha_ampliacion
                  ? $moment(props.item.fecha_ampliacion).format("DD/MM/YYYY")
                  : ""
              }}
            </td>
            <td class="text-xs-center">{{ props.item.porcentaje }}%</td>

            <td class="nowrap text-xs-center">
              <v-btn
                color="info"
                :to="`/vacaciones-listado-unidades/${props.item.gestion}`"
                icon
                title="Ver programaciones de vacación"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <!-- v-if="
                  props.item.id_estado_programacion == 22 ||
                  props.item.id_estado_programacion == 51 ||
                  props.item.id_estado_programacion == 73 ||
                  props.item.id_estado_programacion == 66 ||
                  props.item.id_estado_programacion == 54
                " -->

              <v-btn
                v-if="props.item.id_estado != 72"
                color="indigo"
                @click="finalizarProgramacionesDelMinisterio(props.item)"
                icon
                dark
                title="Finalización de programación RRHH"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <!-- v-if="props.item.id_estado_programacion =! 22 && props.item.id_estado_programacion != 51 && props.item.id_estado_programacion != 73 && props.item.id_estado_programacion != 66 && props.item.id_estado_programacion != 54"
                 -->
              <!-- v-if="props.item.comprobante" -->
              <v-btn
                v-if="props.item.id_estado == 72"
                color="rgba( 89, 184, 34,0.3)"
                @click="
                  informacionProgramacionesDelMinisterio(
                    props.item,
                    props.item.comprobante
                  )
                "
                icon
                title="Comprobante: finalización de programación"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import FinalizarProgramacionesDelMinisterio from "./dialogs/FinalizarProgramacionesDelMinisterio";
import InformacionProgramacionDelMinisterio from "./dialogs/InformacionProgramacionDelMinisterio";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [],
  // Variables iniciales del componente
  data() {
    return {
      // Cabecera de la tabla
      user: this.$storage.get("user"),
      lista_gestiones: [],
      headers: [
        { text: "Gestión", value: "gestion", align: "center" },
        {
          text: "Fecha inicio de programación",
          value: "fecha_inicio",
          align: "center"
        },
        {
          text: "Fecha fin de programación",
          value: "fecha_fin",
          align: "center"
        },
        {
          text: "Fecha corte de programación",
          value: "fecha_corte",
          align: "center"
        },
        {
          text: "Fecha ampliación de programación",
          value: "fecha_corte",
          align: "center"
        },
        {
          text: "Porcentaje de programación",
          value: "porcentaje",
          align: "center"
        },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      nro_item: null,
      persona: null
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  async mounted() {
    // Verificando si el usuario tiene permiso para interactual con el componente
    await this.cargarGestiones();
    await this.cargarInformacionUsuario();
    await this.verificarAprobacionRRHH();
    //this.onFilter();
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }
    this.$bus.$on(
      "closeDialogFinalizarProgramacionesDelMinisterio",
      async () => {
        this.updateList();
        await this.verificarAprobacionRRHH();
      }
    );
    this.$bus.$on(
      "closeDialogInformacionFinalizarProgramacionesDelMinisterio",
      () => {}
    );
  },
  // Métodos y funciones del componente
  methods: {
    async cargarGestiones() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
           query {
              runQuery(consulta:"select * from vacaciones.v_programacion")
  								{
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;

        this.lista_gestiones = respuesta;
      } catch (error) {
        console.log(errror);
      }
    },
    informacionProgramacionesDelMinisterio(item, comprobante) {
      item.comprobante2 = comprobante;
      this.$bus.$emit("openDialogInformacionProgramacionDelMinisterio", item);
    },
    finalizarProgramacionesDelMinisterio(item) {
      this.$bus.$emit("openDialogFinalizarProgramacionDelMinisterio", item);

      ///this.$confirm("Usted no cuenta con vacaciones para programar", () => {});
    },
    obtenerIdUnidad() {
      let user = this.$storage.get("user").unidad;
      return user[0].id;
    },
    async verificarAprobacionRRHH() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
           query {
              runQuery(consulta:"SELECT * FROM vacaciones.v_programacion")
  								{
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
      }
    },

    async cargarInformacionUsuario() {
      let user = this.$storage.get("user");
      let id_persona = user.id_persona;
      try {
        let id_item = null;
        let rpta = await this.$service.graphql({
          query: `
						query{
            vMovimientosMovilidads(id_persona:${id_persona}){
                rows{
                  id
                  fecha_desde
                  fecha_incorporacion
                  id_persona
 
                }
              }
            }
					`
        });

        if (rpta.vMovimientosMovilidads.rows.length != 0) {
          this.fecha_ingreso =
            rpta.vMovimientosMovilidads.rows[0].fecha_incorporacion;
        }
      } catch (error) {
        console.log(error);
      }
    }
  },

  // Definición de componentes importados
  components: {
    FinalizarProgramacionesDelMinisterio,
    InformacionProgramacionDelMinisterio
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/VacacionesGestionRRHH.vue